import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import { useEventListItem } from './useEventListItem';
import ECGSlider from './ecgSlider';
import EventListItemHeader from './header/header';
import type { EventListItemProps } from './index.types';
import './styles.scss';

const EMPTY_ARRAY: any[] = [];
/**
 * Empty default callback standing in for an event handler prop that was not supplied. Takes no arguments and performs no work.
 *
 * @returns Nothing.
 */
const NOOP = () => {};

const EventListItem = ({
  isEventAdvance = false,
  isLoadedData,
  checkedEventIds = EMPTY_ARRAY,
  handleCheck = NOOP,
  data,
  event,
  hasIcon = false,
}: EventListItemProps) => {
  const { state, isEventChecked } = useEventListItem({
    isEventAdvance,
    checkedEventIds,
    data,
    event,
  });

  return isLoadedData ? (
    <div id={event?.id} className="event-list-item w-100 flex flex-column">
      <EventListItemHeader
        checked={isEventChecked}
        handleCheck={handleCheck}
        titleBlockArray={data.headerData.titleBlockArray}
        buttonList={data.headerData.buttonList}
        isHideCheckBox={isEventAdvance}
        isNotCanEdit={state.isNotCanEdit}
        eventId={data.eventId}
        eventList={data}
      />
      <ECGSlider
        isNotCanEdit={state.isNotCanEdit}
        conflictUsers={state.conflictUsers}
        isEventAdvance={isEventAdvance}
        infoData={data.infoData}
        hasIcon={hasIcon}
        hasColorBorder={isEventChecked}
        eventId={event?.id}
      />
    </div>
  ) : (
    <div
      className={classNames(
        'event-list-item-skeleton-container',
        isEventAdvance ? '--advanced-event' : '',
      )}
    >
      <div className="header-container">
        <div className="left-container">
          <div className={isEventAdvance ? 'hidden' : 'item-checkbox mr-24'} />
          <div className="skeleton-container">
            <Skeleton height="100px" />
          </div>
        </div>

        <div className="right-container">
          <div className="skeleton-container">
            <Skeleton height="100px" />
          </div>
        </div>
      </div>

      <div className="content-container">
        <div className="info-container">
          <Skeleton height="100px" />
        </div>
        {!isEventAdvance && (
          <div className="slider-container">
            <Skeleton height={372} />
          </div>
        )}
      </div>
    </div>
  );
};

export default EventListItem;
